export default {
  titles: 'Unterschriftsfelder',
  defaultHint: 'Der Bericht zeigt diese Abteilungen in seiner Sprache, bis Sie sie ändern.',
  titlePlaceholder: 'Titel des Unterschriftsfelds',
  addTitle: 'Unterschriftsfeld hinzufügen',
  titleTooLong: 'Geben Sie höchstens {maxLength} Zeichen ein.',
  restoreDefaults: 'Standardwerte wiederherstellen',
  titleEmpty: 'Geben Sie einen Titel ein.',
  defaultDepartments: {
    material: 'Werkstoff',
    quality: 'Qualität',
    engineering: 'Technik',
    manufacturing: 'Fertigung',
    program: 'Programm',
    customer: 'Kunde',
  },
};
